import FollowerModal from 'modals/FollowerModal/FollowerModal'

export default FollowerModal
